module.exports = __webpack_public_path__ + "static/media/EarthquakeIcon.cffcd26c.svg";